import { useNavigate } from "react-router-dom";
import { useFinancesNavigationState } from "web_myplann/Finances/Hooks/useFinancesNavigationState";
import {
	type FinancesNavigationState,
	FinancesOrigin,
} from "web_myplann/Finances/Types/FinancesNavigationState";

export const useFinancesWizardNavigation = () => {
	const navigate = useNavigate();
	const navigationState = useFinancesNavigationState();

	const isFromProfile = navigationState.from === FinancesOrigin.Profile;

	const goToStep = (
		path: string,
		state: FinancesNavigationState = navigationState,
	) => {
		navigate(path, { replace: true, state });
	};

	return { navigationState, isFromProfile, goToStep };
};
